export enum OPPORTUNITY_STATUS {
  active = 'active',
  draft = 'draft',
  inactive = 'inactive',
  rejected = 'rejected',
  requested = 'requested',
}
